import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";

// Lazy so the route file doesn't eagerly pull the tabs page (which imports
// nav-tabs.config) during config initialization — avoids a circular-import TDZ.
const MSTeamsPage = lazy(() =>
  import("@/pages/(home)/(my-space)/teams").then((m) => ({
    default: m.MSTeamsPage,
  })),
);
const MSTeamsListPage = lazy(
  () => import("@/pages/(home)/(my-space)/teams/list"),
);

export enum MS_TEAMS_PATH_SEGMENTS {
  ROOT = "teams",
}

export const myspaceTeamsRoutes: RouteObject = {
  path: MS_TEAMS_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner,
  handle: { breadcrumb: "Teams" },
  children: [
    // ── Page-level tabs layout (single "My Teams" tab at the module root) ────
    {
      Component: MSTeamsPage,
      handle: { flushContent: true },
      children: [{ index: true, Component: MSTeamsListPage }],
    },
  ],
};

export const MS_TEAMS_PATHS = Object.freeze({
  ROOT: addSlashes(MS_TEAMS_PATH_SEGMENTS.ROOT),
});
